import React from 'react'

function Others() {
  return (
    <div className='testContainer'> Others Community</div>
  )
}

export default Others;